var React = require('react');

function IconSearchInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("path",{"d":"M14.78 14.404c2.261-2.748 2.14-6.842-.279-9.44-4.169-4.35-11.51-.95-11.624 5.08-.059 2.739 1.441 5.254 3.822 6.41 2.38 1.155 5.19.731 7.16-1.08a15.45 15.45 0 0 1 2.223 2.08 14.68 14.68 0 0 1 2.08 2.87l1.36-1.41a16.265 16.265 0 0 1-4.743-4.51zm-8.99-.35c-1.584-1.378-2.285-3.572-1.812-5.667.474-2.094 2.041-3.73 4.048-4.224 2.007-.494 4.11.238 5.43 1.89 1.584 1.38 2.286 3.573 1.812 5.667-.473 2.095-2.04 3.73-4.048 4.224-2.007.494-4.11-.237-5.43-1.89z","fill":"#FFF","fillRule":"nonzero"})));
}

IconSearchInline.defaultProps = {"width":"23","height":"24","viewBox":"0 0 23 24"};

module.exports = IconSearchInline;

IconSearchInline.default = IconSearchInline;
